import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import moment from 'moment';
import { EventsProvider } from '../../providers/events/events';
import { Platform } from 'ionic-angular/platform/platform';
import { AppState } from '../../config/state';
import { ClientDetailsProvider } from '../../providers/client-details/client-details';
import { ModalController } from 'ionic-angular';
import { CoEventPopupDetailsPage } from '../../pages/co-event-popup-details/co-event-popup-details';
import { FilteringProvider } from '../../providers/filtering/filtering';

/**
 * Generated class for the CoEventsMonthDropdownComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-events-month-dropdown',
  templateUrl: 'co-events-month-dropdown.html'
})
export class CoEventsMonthDropdownComponent {

  @Input('popOverFilter') popOverFilter: any;
  @Input('currentDate') currentDate: any;
  monthDays: any = [];
  startingDay: any;
  endingDay: any;
  rawQueryData: any;
  filteredWeek: any;
  searchTypes: any;
  eventsArray: any;
  currentPopper: any;
  currentEvent: any;
  clientKeyword: string;
  viewType: any;
  currentDay: any;
  todaysDate: any;
  @Output() onDatePicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() eventQueryTimeArgs: EventEmitter<any> = new EventEmitter<any>();
  aboveWidthBreakpoint: any;
  public devWidth = this.platform.width();
  eventsToShow: number = 5;
  currentRow: any;
  currentRowChildren: any;
  currentSelectedCard: any;
  eventListDropdown: any;
  selectedDayEvents: any = [];
  @ViewChild('monthDropdown') monthDropdown;
  @ViewChild('dropdownList') dropdownList;

  constructor(private eventsProvider: EventsProvider, private platform: Platform, private state: AppState, private clientDetails: ClientDetailsProvider, public modalCtrl: ModalController, public filteringProvider: FilteringProvider) {
    let self = this;
    this.clientDetails.load().then(function (response) {
      self.clientKeyword = response.keyword;
      self.viewType = self.state.mode;
      self.platform.width() > 992 ? self.aboveWidthBreakpoint = true : self.aboveWidthBreakpoint = false;
    });
  }

  ngOnInit() {
    this.todaysDate = moment();
    this.currentDay = moment(this.currentDate);
    this.initializeCalendar(this.currentDay);
  }

  initializeCalendar(currentDate) {
    let eventsQueryArgs = `startDate: "${moment(currentDate).startOf('month').startOf('week').startOf('day').format("YYYY-MM-DD HH:mm:ss")}", endDate: "${moment(currentDate).add(42, 'day').format("YYYY-MM-DD HH:mm:ss")}"`;
    this.queryEvents(eventsQueryArgs);
    this.startingDay = moment(currentDate).startOf('month').startOf('week');
    this.endingDay = moment(this.startingDay).add(42, 'day');
  }

  updateBrochureStartDay(){
    this.eventQueryTimeArgs.emit({start: moment(this.currentDate).startOf('month').format("YYYY-MM-DD"), end: moment(this.currentDate).endOf('month').format("YYYY-MM-DD")});
  }

  queryEvents(args) {
    let eventsResponse;
    this.eventsProvider.getEvents(args).then((res) => {
      this.updateBrochureStartDay();
      eventsResponse = res.allEvents;
      this.rawQueryData = res.allEvents;
      this.filteredWeek = res.allEvents;
      this.searchTypes = res.searchTypes;
      this.selectedDayEvents = res.allEvents;
      this.filterByPopOver(this.popOverFilter);
    });
  }

  filterByPopOver(filterObj){
    this.filteringProvider.filterByPopover(filterObj, this.rawQueryData).then((res)=>{
      this.rebuildPage(res);
    })
  }

  rebuildPage(info) {
    let weekArray = [[], [], [], [], [], []]
    let dayForPage = 0;

    this.monthDays = [];
    for (let i = 0; i < 42; i++) {
      this.monthDays.push(moment(this.startingDay).add(i, 'day'))
    }

    //for each week in month
    weekArray.forEach((array, i) => {
      let dayArray = [[], [], [], [], [], [], []];
      //for each day in week
      dayArray.forEach((dayOfWeekArray, j) => {
        let checkDay = moment(this.startingDay).add(dayForPage, 'day').dayOfYear();

        //for each event in day
        info.forEach(event => {
          if (checkDay === moment(event.eventStart).dayOfYear()) {
            //if date matches, push to day of week array
            dayOfWeekArray.push(event);
          }
        });
        dayForPage++;
      })
      array.push(dayArray);
      // weekForPage++;
    });
    this.eventsArray = weekArray;
  }


  getEventColor(eventType, barOrText) {
    if (barOrText == 'text') {
      try {
        let eventTypeObject = this.searchTypes.find(object => object.name === eventType);
        return eventTypeObject.color;
      } catch (ex) {
        return "green";
      };
    }
    else {
      try {
        let eventTypeObject = this.searchTypes.find(object => object.name === eventType);
        return "2px solid " + eventTypeObject.color;
      } catch (ex) {
        return "green";
      };
    }
  }

  // toggleHover(info, toggle, currentEvent) {
  //   this.currentEvent = currentEvent;
  //   const reference = info.target.firstChild.parentElement.parentElement.parentElement;
  //   const onPopper = document.querySelector('#eventSnapshotPopper');
  //   const arrow = document.querySelector('#arrowPopper');
  //   // this.hovering = true;
  //   if (toggle && onPopper != null) {
  //     let popper: any;
  //     popper = new Popper(reference, onPopper, {
  //       placement: 'right-start',
  //       modifiers: {
  //         keepTogether: {
  //           enabled: true
  //         }
  //       },
  //       onCreate: (data) => {
  //         // popper.popper.style.display = "block";
  //         popper.disableEventListeners();
  //       },
  //     });
  //     this.currentPopper = popper;

  //   }
  //   else {
  //     // this.hovering = false;
  //     // this.currentPopper.popper.style.display = "none";
  //     // this.currentPopper.destroy();
  //   }
  // }

  nextMonth() {
    this.currentDay = moment(this.currentDay).add(1, 'month').format("YYYY-MM-DD HH:mm:ss");
    this.initializeCalendar(this.currentDay);
    this.onDatePicked.emit(this.currentDay);
    try {
      let wholeDocument: any = document.body;
      wholeDocument.append(this.eventListDropdown);
      this.eventListDropdown.setAttribute('style', `display: none;`);
    }
    catch (ex) {
      console.log('no drop downs in view')
    }
  }

  previousMonth() {
    this.currentDay = moment(this.currentDay).subtract(1, 'month').format("YYYY-MM-DD HH:mm:ss");
    this.initializeCalendar(this.currentDay);
    this.onDatePicked.emit(this.currentDay);
    try {
      let wholeDocument: any = document.body;
      wholeDocument.append(this.eventListDropdown);
      this.eventListDropdown.setAttribute('style', `display: none;`);
    }
    catch (ex) {
      console.log('no drop downs in view')
    }
  }

  expandCell(data, idString, selectedDay, closeCard) {
    if (this.currentSelectedCard) {
      this.currentSelectedCard.classList.remove("arrowDown");
    }

    // if (this.currentSelectedCard) {
    //   this.currentSelectedCard.setAttribute('style', `
    //   border: solid 1px #e6e6e6;
    //   `);

      // this.currentRowChildren.forEach(element => {
      //   element.setAttribute('style', `
      //   border: solid 1px #e6e6e6;
      //   `);
      // });
    // }
    let row: any;
    row = this.monthDropdown.nativeElement.querySelector('#' + idString);
    let rowChildren: any = Array.from(row.querySelectorAll('.calendar-date'));
    let selectedCard;
    selectedCard = data.target.parentElement;

    try {
      let wholeDocument: any = document.body;
      wholeDocument.append(this.eventListDropdown);
      // wholeDocument.append(arrowDown);

      this.eventListDropdown.setAttribute('style', `display: none;`);

    }
    catch (ex) {
      console.log('no drop downs in view')
    }

    if (this.currentSelectedCard === selectedCard || closeCard) {
      this.currentSelectedCard = undefined;
      this.currentRowChildren = undefined;
      this.currentRow = undefined;

      return;
    }

    // rowChildren.forEach(element => {
    //   element.setAttribute('style', `
    //   border-bottom: solid 2px #2394E3;
    //   `);
    // });

    // selectedCard.setAttribute('style', `
    //   border-left: solid 3px #2394E3;
    //   border-right: solid 3px #2394E3;
    //   border-top: solid 3px #2394E3;
    //   border-bottom: solid 2px #2394E3;
    // `);
    if (!this.eventListDropdown) {
      // this.eventListDropdown = document.querySelector('.eventDropdownList');
      this.eventListDropdown = this.dropdownList.nativeElement;
    }

    // this.eventListDropdown = newList;
    row.append(this.eventListDropdown);
    // selectedCard.append(arrowDown);

    selectedCard.classList.add("arrowDown");
    this.currentSelectedCard = selectedCard;
    this.currentRowChildren = rowChildren;
    this.currentRow = row;

    this.selectedDayEvents = [];
    this.selectedDayEvents = this.rawQueryData.filter(event => moment(selectedDay).isSame(moment(event.eventStart), 'day'));
    this.eventListDropdown.setAttribute('style', `display: block;`);
  }

  openEventCard(currentEvent) {
    let modal = this.modalCtrl.create(CoEventPopupDetailsPage, { currentEvent: currentEvent, searchTypes: this.searchTypes, clientKeyword: this.clientKeyword },{ cssClass: 'eventDetailsModal' });
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/components/co-events-month-dropdown/co-events-month-dropdown.ts